import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TreeViewDelay } from "./components/DelayConfiguration/TreeViewDelay";
import type { DelayCodeLabels } from "./delayCodeLabels";

interface Props {
  delayAreaAssetId?: number;
  delayAreaAssetName?: string;
  displayName?: string;
  labels: DelayCodeLabels;
}
export const CatalogDelayCodePage = ({
  delayAreaAssetId,
  delayAreaAssetName,
  displayName,
  labels,
}: Props) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <TreeViewDelay
        delayAreaAssetId={delayAreaAssetId}
        delayAreaAssetName={delayAreaAssetName}
        displayName={displayName}
        labels={labels}
      />
    </DndProvider>
  );
};
